import { render, staticRenderFns } from "./MessageShow.vue?vue&type=template&id=03fb4f98&scoped=true&"
import script from "./MessageShow.vue?vue&type=script&lang=js&"
export * from "./MessageShow.vue?vue&type=script&lang=js&"
import style0 from "./MessageShow.vue?vue&type=style&index=0&id=03fb4f98&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fb4f98",
  null
  
)

export default component.exports